import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import {Observable, throwError} from 'rxjs';
import { CustomsValidators } from '../../validators/custom.validators';

@Injectable({
  providedIn: 'root'
})
export class PickupCardService {
  url: string;


  constructor(private http: HttpClient) {
    this.url = `${environment.bffBaseUrl}/pages/pickup-cards`;
  }

  getPickupsCards(): Observable<any> {
    const urlBuilder = this.url;
    return CustomsValidators.isValidUrl(urlBuilder) ? this.http.get(urlBuilder) : throwError(CustomsValidators.msgNotValidUrl);
  }

  getPickupImage(Siteid, PickupId) {
    const urlBuilder = `${this.url}/${Siteid}/pickup-map/${PickupId}`;
    return CustomsValidators.isValidUrl(urlBuilder) ? this.http.get(urlBuilder) : throwError(CustomsValidators.msgNotValidUrl);
  }

}
